import * as yup from 'yup';
import i18next from 'i18next';
import { PapiRequestDreamsofartGenerate } from '@wix/da-papi-types';

/**
 * Yup validation schema for dreamup generate requests
 * Matches the UI constraints and prevents 400 errors
 */
const testMaxBytes = (maxBytes: number) => {
  return yup
    .string()
    .optional()
    .test(
      'max-bytes',
      i18next.t('validation.dreamup.maxBytes', { max: maxBytes }),
      value => {
        if (!value) return true;
        return new Blob([value]).size <= maxBytes;
      }
    );
};
const dreamupGenerateValidationSchema = yup.object({
  prompt: yup.string().max(400).optional().concat(testMaxBytes(400)),
  negative_prompt: yup.string().max(400).optional().concat(testMaxBytes(400)),
  use_points: yup.boolean().optional(),
  deviationid: yup.number().integer().positive().optional(),
  similarity: yup.number().integer().min(1).max(100).optional(), // UI slider is 1-100
  aspect_ratio: yup
    .string()
    .oneOf(['1:1', '3:4', '4:3', '16:9', '9:16'])
    .optional(),
  guidance_scale: yup.number().integer().min(0).max(20).optional(),
  style: yup
    .string()
    .oneOf([
      'default',
      'anime',
      'anthro',
      'photographic',
      'fantasy',
      'vaporwave',
      'lowpoly',
      'origami',
      'line_art',
      'craft_clay',
      'cinematic',
      '3d_model',
      'pixel_art',
    ])
    .optional(),
  output_format: yup.string().oneOf(['png', 'jpg']).optional(),
});

/**
 * Validate dreamup generate request data to prevent 400 errors
 * Returns true if valid, false if invalid
 * Uses Yup validation following da-shared-react patterns
 */
export function validateDreamupGenerateRequest(
  requestData: PapiRequestDreamsofartGenerate
): boolean {
  try {
    dreamupGenerateValidationSchema.validateSync(requestData);
    return true;
  } catch {
    return false;
  }
}
